import React from "react";
import { ButtonProps } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import BrandButton from "../BrandButton/BrandButton";

interface PrintButtonProps extends Omit<ButtonProps, "onClick"> {
  targetRef: React.RefObject<HTMLElement | HTMLDivElement | null>;
  title?: string;
  label?: string;
  showIcon?: boolean;
}

const PrintButton: React.FC<PrintButtonProps> = ({
  targetRef,
  title,
  label,
  showIcon = true,
  ...props
}) => {
  const { t } = useKivunovaTranslation();
  const displayLabel = label ?? t("print-button-label", "Print");

  const handlePrint = useReactToPrint({
    contentRef: targetRef,
    documentTitle: title
  });

  return (
    <BrandButton
      startIcon={showIcon ? <PrintIcon /> : undefined}
      onClick={handlePrint}
      {...props}
    >
      {displayLabel}
    </BrandButton>
  );
};

export default PrintButton;
